module.exports = __webpack_public_path__ + "img/ch23_02_星光之战.76cbdcf8.jpg";